// Local imports
import * as event from '../../datalayer/event.js';
import { GIFT_CATALOGUE as PRODUCT_DATALAYER } from '../../datalayer/data/gift_catalogue.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';

// Product is an object that contains only the following attributes:
// * id
// * title
// * variants
// * img_url
// * ismonthly
export function update_product_datalayer(
    product,
    ispromo,
    position,
    collection_title
) {
    PRODUCT_DATALAYER.id.push(product.id);
    PRODUCT_DATALAYER.name.push(product.title);

    let brand = product.ismonthly === 'true' ? 'Pledge' : 'One Time Donation';
    PRODUCT_DATALAYER.brand.push(brand);

    PRODUCT_DATALAYER.variant.push(product.variants);
    PRODUCT_DATALAYER.category.push(collection_title);
    if (ispromo === 'true') {
        PRODUCT_DATALAYER.promo_id.push(product.id);
        PRODUCT_DATALAYER.promo_name.push(product.title);
        PRODUCT_DATALAYER.promo_creative.push(product.img_url);
        PRODUCT_DATALAYER.promo_position.push(position);
    } else {
        PRODUCT_DATALAYER.promo_id.push('');
        PRODUCT_DATALAYER.promo_name.push('');
        PRODUCT_DATALAYER.promo_creative.push('');
        PRODUCT_DATALAYER.promo_position.push('');
    }
}

// ===========================================================================
// Click datalayer
// ===========================================================================

// Product is an object that contains only the following attributes:
// * id
// * name
// * category
// * price
// * variant_size
// * variants
export function init_buttonclick_handler(global, product) {
    let utag_data = global.utag_data;

    let button = global.document.querySelector('#to_cart');
    button.addEventListener('click', event => {
        event.preventDefault();
        onclick_product_button(global, utag_data, product);
    });
}

function onclick_product_button(global, utag_data, product) {
    let quantity = global.document.querySelector('.js-quantity-hook')
        .attributes['value'].value;
    let price = product.price;
    let variant_size = parseInt(product.variant_size);
    let variant_id = product.variants[0].id;

    if (variant_size > 1) {
        let sku = global.document.querySelector(
            '#giftCatalogueSelectedVariantSku'
        ).attributes['value'].value;

        for (let variant of product.variants) {
            if (variant.sku === sku) {
                variant_id = variant.id;
                price = variant.price;
                break;
            }
        }
    }

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Add to Cart';
    utag_data['event_label'] =
        'Gift Catalogue Product Detail Page Added To Cart';

    utag_data['product_price'] = price;
    utag_data['product_id'] = product.id;
    utag_data['product_name'] = product.name;
    utag_data['product_brand'] = 'One Time Donation';
    utag_data['product_variant'] = variant_id;
    utag_data['product_category'] = product.category;
    utag_data['product_quantity'] = quantity;

    //== gtm-push: OGC Product added to cart from product page ==//
    let data_object = {
        event: 'add_to_cart',
        ecommerce: {
            products: [
                {
                    item_name: product.name,
                    item_id: product.id,
                    price: price,
                    item_brand: 'One Time Donation',
                    item_category: product.category,
                    item_variant: variant_id,
                    item_list_name: 'Gift Catalogue Products List',
                    quantity: quantity,
                },
            ],
        },
    };
    push_data_object(data_object);

    event.dispatch(global, event.EventKind.AddToCart);
}

// ===========================================================================
//
// ===========================================================================
